import { useState } from "react";
import { Check, Loader2, LogOut } from "lucide-react";

const BENEFITS = [
  "Unlimited AI Grant Writer proposal drafts",
  "Unlimited Bid Readiness Scorer reports",
  "On-demand Capability Statement PDF",
  "Cancel anytime",
];

export function MemberPaywall({ member, onSubscribe, onLogout, onRefreshAccess }) {
  const [submitting, setSubmitting] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = async () => {
    setSubmitting(true);
    setError("");
    const res = await onSubscribe();
    if (!res.ok) {
      setError(res.error || "Could not start checkout. Please try again.");
      setSubmitting(false);
    }
  };

  const handleRefresh = async () => {
    if (!onRefreshAccess) return;
    setRefreshing(true);
    setError("");
    const status = await onRefreshAccess();
    if (!status || status !== "active") {
      setError("We could not confirm an active subscription yet. If you just subscribed, please wait a moment and try again.");
    }
    setRefreshing(false);
  };

  return (
    <div className="max-w-xl mx-auto px-6 pt-20 pb-24 text-center" data-testid="member-paywall">
      <div className="overline text-[var(--red)] mb-4">Welcome, {member.name?.split(" ")[0] || "there"}</div>
      <h1 className="font-display font-semibold text-3xl sm:text-4xl tracking-tight mb-6">
        Activate your Grant Partnership
      </h1>
      <div className="card-dark p-8 text-left mb-8">
        <div className="flex items-baseline gap-2 mb-6">
          <span className="font-display text-4xl font-semibold">$1,000</span>
          <span className="text-[var(--text-2)]">/month</span>
        </div>
        <ul className="space-y-3 mb-2">
          {BENEFITS.map((b) => (
            <li key={b} className="flex items-start gap-3 text-sm text-[var(--text-2)]">
              <Check className="w-4 h-4 text-[var(--red)] mt-0.5 shrink-0" /> {b}
            </li>
          ))}
        </ul>
      </div>
      {error && <div className="text-sm text-[var(--red)] mb-4" data-testid="member-subscribe-error">{error}</div>}
      <button
        onClick={handleSubscribe}
        disabled={submitting}
        className="btn-red w-full justify-center mb-4"
        data-testid="member-subscribe-btn"
      >
        {submitting ? (<><Loader2 className="w-4 h-4 animate-spin" /> Redirecting to checkout…</>) : "Subscribe — $1,000/mo"}
      </button>
      <button
        onClick={handleRefresh}
        disabled={refreshing}
        className="btn-ghost w-full justify-center mb-4"
        data-testid="member-refresh-access-btn"
      >
        {refreshing ? (<><Loader2 className="w-4 h-4 animate-spin" /> Checking subscription…</>) : "I already subscribed — refresh access"}
      </button>
      <button onClick={onLogout} className="text-xs text-[var(--text-3)] hover:text-white flex items-center gap-2 mx-auto" data-testid="member-logout-btn">
        <LogOut className="w-3.5 h-3.5" /> Sign out
      </button>
    </div>
  );
}
